import React, { Component } from 'react'

import AspectRatio from '../../atoms/AspectRatio'
import ActionBtnIcon from '../ActionBtnIcon'
import ProgressBar from '../../atoms/ProgressBar'
import Valign from '../../atoms/Valign'

import style from './style.css'


export default class ImagePreview extends Component {

    state = {
        image: null
    }

    componentWillMount() {
        if(this.props.file) {
            let image = URL.createObjectURL(this.props.file)
            if(this.props.imageURL) this.props.imageURL(image)
            this.setState({
                image
            })
        }

        this.componentWillUpdate(this.props)
    }

    componentWillUpdate(nextProps) {
        if(nextProps.image && nextProps.image !== this.state.image) {
            this.setState({
                image: nextProps.image
            })
        } else {
            if(nextProps.file && nextProps.file !== this.props.file) {
                let image = URL.createObjectURL(nextProps.file)

                if(nextProps.imageURL) nextProps.imageURL(image)

                this.setState({
                    image
                })
            }
        }
    }

    render() {
        const props = this.props


        return (
                <div className={`${style.box}`}>
                  <AspectRatio
                     ratio='3x1'
                     image={this.state.image}
                     style={{
                        backgroundSize: 'cover'
                     }}
                  >
                        {props.status === 'loading' && (
                           <div className={style.shadow}>
                                 <Valign>
                                    <ProgressBar theme='orange' progress={props.progress} />
                                    {props.textProgress && (
                                          <span style={{ color: '#fff', marginTop: '20px' }}>
                                          {props.textProgress}
                                          </span>
                                    )}
                                 </Valign>
                           </div>
                        )}

                        {(props.status !== 'loading') && (
                           <span
                              style={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '10px'
                              }}>
                              <ActionBtnIcon
                                    theme='rounded-orange'
                                    icon='trash'
                                    action={() => {
                                    props.onRemove()
                                    }}
                                    />
                           </span>
                        )}

                  </AspectRatio>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/ImagePreview/index.js